import routes from './routes'
import store from './store'

export default {
    name: 'm-localization',
    store: store,
    routes: routes
}